/** Major API version (payzhe BTP Kotlin uses `"1"`; tolerate `"1.0"` from legacy builds). */
export function normalizeApiMajor(raw: string): string {
  const trimmed = raw.trim();
  const major = trimmed.split('.')[0]?.split('-')[0];
  return major || trimmed;
}

export function isApiVersionCompatible(reported: string, expected: string): boolean {
  return normalizeApiMajor(reported) === normalizeApiMajor(expected);
}

/** Compare dotted semver strings. Returns negative if a < b, 0 if equal, positive if a > b. */
export function compareSemver(a: string, b: string): number {
  const pa = a.trim().split('.').map((part) => Number.parseInt(part, 10) || 0);
  const pb = b.trim().split('.').map((part) => Number.parseInt(part, 10) || 0);
  const len = Math.max(pa.length, pb.length, 3);
  for (let i = 0; i < len; i += 1) {
    const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (diff !== 0) return diff;
  }
  return 0;
}

export function isVersionOlder(installed: string, latest: string): boolean {
  return compareSemver(installed, latest) < 0;
}
